import React, { memo } from 'react';
import { hydrate } from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import getBrowserHistory from 'yoda-core-components/lib/navigation/history/getBrowserHistory';
import ErrorFullPageLazy from './components/ErrorFullPage/ErrorFullPageLazy';
import ContextProvider from './components/ContextProvider';

const MemoizedErrorFullPageLazy = memo(ErrorFullPageLazy);

const renderApp = (App, ErrorPage, context, container, customErrorPageComponent, store) => {
    const { status } = ErrorPage || {};

    const routerElement = (
        <Router history={getBrowserHistory()}>
            {ErrorPage ? (
                <MemoizedErrorFullPageLazy
                    customErrorPageComponent={customErrorPageComponent}
                    templateType={status}
                />
            ) : (
                <App />
            )}
        </Router>
    );

    hydrate(
        <ContextProvider context={context}>
            <Provider store={store} key="provider">
                {routerElement}
            </Provider>
        </ContextProvider>,
        container
    );
};

export default renderApp;
